module.exports = __webpack_public_path__ + "static/media/polar-bear-question.4998c3f8.png";